import React from 'react';
import { number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import {
  Card,
  CardContent,
  CardFootnote,
  CardTitle,
} from '@thd-olt-component-react/core-ui';
import { StoreWorkshops } from '@thd-olt-component-react/store-workshops';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

const OnlineWorkshopsPropTypes = {
  renderWidths: {
    minWidthLarge: number,
  },
};

const OnlineWorkshopsDefaultProps = {
  renderWidths: {
    minWidthLarge: undefined,
  },
};

export function CustomRenderedOnlineWorkshops({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,

  isB2B,
}) {
  function OnlineWorkshops({ renderWidths: { minWidthLarge } }) {
    const isCard = minWidthLarge < 5;

    if (isB2B) return null;

    return (
      <QueryProvider cacheKey="asd">
        <Hydrator
          id="onlineWorkshops-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          delay={HOMEPAGE_DELAY_STANDARD}
          placeholder={PLACEHOLDER}
        >
          <Card>
            <div>
              <CardTitle
                className="card__title"
                title="Kids Workshops Are Back in Store"
              />
              <CardContent>
                <div
                  className={
                    !isCard ? 'store-workshop-half' : 'store-workshop-card'
                  }
                >
                  <StoreWorkshops />
                </div>
              </CardContent>
            </div>
            <CardFootnote
              className="u-width-100 u-flex-end"
              link={{
                label: 'View Upcoming Kids Workshops',
                href: '/kids',
              }}
            />
          </Card>
        </Hydrator>
      </QueryProvider>
    );
  }

  OnlineWorkshops.propTypes = OnlineWorkshopsPropTypes;
  OnlineWorkshops.defaultProps = OnlineWorkshopsDefaultProps;

  return OnlineWorkshops;
}
